import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import './styles/classes.css'

//Components
import Loader from '../components/loader'
import Menu from '../components/menu'

//Extras
import { fontType, levelColors, main } from '../assets/extras'
import { collection, doc, getDocs, limit, onSnapshot, orderBy, query, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import { horas, niveles, dias, categorias } from '../assets/datas'

const Classes = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [ variables, setVariables ] = useState({
        loading: true,
        clinics: [],
        teachers: [],
        sedes: [],
        search: "",
        dia: "",
        nivel: "",
        categoria: "",
        profesor: "",
        sede: ""
    })

    //Variable que almacena los datos ordenados por dias
    var sortedDaysData = [
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for(let i = 0; i < 7; i++){
            if(i === 0){ //Lunes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Lunes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 1){ //Martes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Martes"){
                        sortedDaysData[i].push(clase)
                        cont ++;
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 2){ //Miercoles
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Miercoles"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 3){ //Jueves
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Jueves"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 4){ //Viernes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Viernes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 5){ //Sabado
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Sabado"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 6){ //Domingo
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Domingo"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            }
        }
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            onSnapshot(query(collection(doc(db, ref), "Clases")), async queryClases => {
                var aux = []

                //Iteramos sobre cada clase
                queryClases.docs.map(v => {
                    const id = v.id

                    //Validamos que esta sea solamente de las registradas, sin ser sustituciones ni extras
                    if(id.split("-").length === 1){

                        var dias_aux = []
                        v.data().dias_clase.map(v => {
                            dias_aux.push(v.dia)
                        })

                        var d = v.data()
                        var newObject = {
                            id: v.id,
                            nombre_clase: d.nombre_clase,
                            profesor_clase: d.profesor_clase,
                            descripcion_clase: d.descripcion_clase,
                            nombre_profesor: d.nombre_profesor,
                            profesor_clase_secundario: d.profesor_clase_secundario || "",
                            nombre_profesor_secundario: d.nombre_profesor_secundario || "",
                            dias_clase: d.dias_clase,
                            nivel: d.nivel,
                            dias: dias_aux,
                            categoria: d.categoria,
                            numero_jugadores: d.numero_jugadores,
                            limite_jugadores: d.limite_jugadores,
                            sede: d.sede || "",
                            nombre_sede: d.nombre_sede || "",
                            sedes: d.sedes || (d.sede ? [d.sede] : []),
                            nombres_sedes: d.nombres_sedes || (d.nombre_sede ? [d.nombre_sede] : [])
                        }

                        aux.push(newObject)
                        
                    }
                })

                //Ordenamos cada clase de la lista de las categorias por dias
                for(let i = 0; i < aux.length; i++){
                    //Recibimos una sola clase de la lista+
                    sortByDay(aux[i])
                }

                var aux2 = []
                //Una vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
                //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
                for(let i = 0; i < sortedDaysData.length; i++){

                    //Primero creamos una variable que contendra las horas de clase
                    var h = horas.map((v, i) => [])

                    for(let x = 0; x < sortedDaysData[i].length; x++){

                        //Creamos una variable que almacena las horas de comienzo de cada clase
                        var start = []

                        //Recorremos cada dia de las clases
                        for(let z = 0; z < sortedDaysData[i][x].dias_clase.length; z++){
                            //Las agregamos a la variable de almacenamiento de las horas
                            start.push(parseInt(sortedDaysData[i][x].dias_clase[z].de))
                        }

                        
                        //Ahora validamos recorriendo las horas a cual pertenece cada una
                        for(let z = 0; z < h.length; z++){
                            if(start.includes((z+1))){
                                h[z].push(sortedDaysData[i][x])
                                break
                            }
                        }

                    }

                    h.map((v, i) => {
                        v.map(v2 => {
                            aux2.push(v2)
                        })
                    })

                }

                var t = []
                await getDocs(query(collection(db, "Profesores"), where("academia_profesor", "array-contains", academia))).then(queryProfesores => {
                    queryProfesores.docs.map(v => {
                        var newObject = {
                            id: v.id,
                            nombre_profesor: v.data().nombre_profesor + " " + v.data().apellido_p_profesor
                        }
                        t.push(newObject)
                    })
                })

                // Cargar sedes
                var sedesAux = []
                try {
                    const sedesSnap = await getDocs(collection(doc(db, ref), "Sedes"))
                    sedesSnap.docs.forEach(v => {
                        sedesAux.push({ id: v.id, nombre_sede: v.data().nombre_sede, es_default: v.data().es_default || false })
                    })
                } catch(e) {
                    // Sin sedes configuradas
                }

                setVariables(prev => ({
                    ...prev,
                    clinics: aux2,
                    teachers: t,
                    sedes: sedesAux,
                    loading: false
                }))
            })
        }
    }, [])

    if(variables.loading){
        return (
            <Loader
                loading={variables.loading}
            />
        )
    }

    if(!variables.loading) {
    const defaultSedeId = variables.sedes.find(s => s.es_default)?.id || variables.sedes[0]?.id || ""
    const filteredClinics = variables.sede
        ? variables.clinics.filter(v => {
            const classSedes = v.sedes && v.sedes.length > 0 ? v.sedes : (v.sede ? [v.sede] : [])
            if (classSedes.length === 0) return variables.sede === defaultSedeId
            return classSedes.includes(variables.sede)
        })
        : variables.clinics

    return (
        <div className='mainClasses'>

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>CLASES</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -40,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <Menu
                academia={academia}
                reference={ref}
            />

            <div className='contCont'>
                <div className='contHeader'>
                    <input
                        maxLength={30}
                        placeholder='Buscar clase'
                        onChange={e => {
                            const t = e.target.value

                            setVariables(prev => ({
                                ...prev,
                                search: t
                            }))
                        }}
                    />

                    <p style={{
                        width: "100%",
                        marginBottom: -8,
                        fontFamily: fontType.text,
                        fontSize: 16,
                        fontWeight: "bold"
                    }}>Seleccionar nivel</p>
                    <div className='custom-select'>
                        <select id="Nivel" name="Nivel" style={{
                            fontFamily: fontType.text
                        }}
                            value={variables.nivel}
                            onChange={e => {
                                setVariables(prev => ({
                                    ...prev,
                                    nivel: e.target.value
                                }))
                            }}
                        >
                            <option value={""}>Ninguno</option>
                            {
                                niveles.map(v => {
                                    return (
                                        <option value={v}>{v}</option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    <p style={{
                        width: "100%",
                        marginBottom: -8,
                        fontFamily: fontType.text,
                        fontSize: 16,
                        fontWeight: "bold"
                    }}>Seleccionar categoria</p>
                    <div className='custom-select'>
                        <select id="Categoria" name="Categoria" style={{
                            fontFamily: fontType.text
                        }}
                            value={variables.categoria}
                            onChange={e => {
                                setVariables(prev => ({
                                    ...prev,
                                    categoria: e.target.value
                                }))
                            }}
                        >
                            <option value={""}>Ninguno</option>
                            {
                                categorias.map(v => {
                                    return (
                                        <option value={v}>{v}</option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    <p style={{
                        width: "100%",
                        marginBottom: -8,
                        fontFamily: fontType.text,
                        fontSize: 16,
                        fontWeight: "bold"
                    }}>Seleccionar dia</p>
                    <div className='custom-select'>
                        <select id="Dia" name="Dia" style={{
                            fontFamily: fontType.text
                        }}
                            value={variables.dia}
                            onChange={e => {
                                setVariables(prev => ({
                                    ...prev,
                                    dia: e.target.value
                                }))
                            }}
                        >
                            <option value={""}>Ninguno</option>
                            {
                                dias.map(v => {
                                    return (
                                        <option value={v}>{v}</option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    <p style={{
                        width: "100%",
                        marginBottom: -8,
                        fontFamily: fontType.text,
                        fontSize: 16,
                        fontWeight: "bold"
                    }}>Seleccionar profesor</p>
                    <div className='custom-select'>
                        <select id="Profesor" name="Profesor" style={{
                            fontFamily: fontType.text
                        }}
                            value={variables.profesor}
                            onChange={e => {
                                setVariables(prev => ({
                                    ...prev,
                                    profesor: e.target.value
                                }))
                            }}
                        >
                            <option value={""}>Ninguno</option>
                            {
                                variables.teachers.map(v => {
                                    return (
                                        <option value={v.id}>{v.nombre_profesor}</option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    {variables.sedes.length > 1 && (
                        <>
                            <p style={{
                                width: "100%",
                                marginBottom: -8,
                                fontFamily: fontType.text,
                                fontSize: 16,
                                fontWeight: "bold"
                            }}>Filtrar por sede</p>
                            <div className='custom-select'>
                                <select style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.sede}
                                    onChange={e => {
                                        setVariables(prev => ({
                                            ...prev,
                                            sede: e.target.value
                                        }))
                                    }}
                                >
                                    <option value={""}>Todas</option>
                                    {variables.sedes.map(s => (
                                        <option key={s.id} value={s.id}>{s.nombre_sede}</option>
                                    ))}
                                </select>
                            </div>
                        </>
                    )}

                    {variables.sedes.length <= 1 ? (
                        <button onClick={() => {
                            navigate("/classes/add", { state: { ref, academia, sedeId: variables.sedes[0]?.id || "", sedeNombre: variables.sedes[0]?.nombre_sede || "" } })
                        }} id="buttonagregar" style={{
                            backgroundColor: main,
                            fontFamily: fontType.subTitle,
                            color: "white",
                            marginTop: 50,
                            border: "none",
                            cursor: "pointer"
                        }}>
                            AGREGAR CLASE
                        </button>
                    ) : (
                        <>
                            <p style={{
                                width: "100%",
                                marginTop: 40,
                                marginBottom: 10,
                                fontFamily: fontType.text,
                                fontSize: 16,
                                fontWeight: "bold",
                                textAlign: "center"
                            }}>Agregar clase en sede:</p>
                            <div style={{
                                width: "100%",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 10,
                                justifyContent: "center"
                            }}>
                                {variables.sedes.map(s => (
                                    <button key={s.id} onClick={() => {
                                        navigate("/classes/add", { state: { ref, academia, sedeId: s.id, sedeNombre: s.nombre_sede } })
                                    }} style={{
                                        padding: "12px 24px",
                                        backgroundColor: main,
                                        border: "none",
                                        borderRadius: 10,
                                        cursor: "pointer",
                                        fontFamily: fontType.subTitle,
                                        fontSize: 14,
                                        color: "white",
                                        transition: "all 0.2s",
                                        opacity: 0.9
                                    }}
                                        onMouseEnter={e => { e.target.style.opacity = "1"; e.target.style.transform = "scale(1.03)" }}
                                        onMouseLeave={e => { e.target.style.opacity = "0.9"; e.target.style.transform = "scale(1)" }}
                                    >
                                        {s.nombre_sede}
                                    </button>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                <div className='contClasses'>
                    {

                        (variables.dia === "") && (variables.nivel === "") && (variables.categoria === "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) ||
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) ||
                                (v.nombre_profesor_secundario && v.nombre_profesor_secundario.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()))).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia === "") && (variables.nivel === "") && (variables.categoria === "") && (variables.profesor != "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia === "") && (variables.nivel === "") && (variables.categoria != "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.categoria === variables.categoria).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && v.categoria === variables.categoria).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia === "") && (variables.nivel === "") && (variables.categoria != "") && (variables.profesor != "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.categoria === variables.categoria && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && v.categoria === variables.categoria && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia === "") && (variables.nivel != "") && (variables.categoria === "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.nivel === variables.nivel).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.nivel === variables.nivel)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia === "") && (variables.nivel != "") && (variables.categoria === "") && (variables.profesor != "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.profesor_clase === variables.profesor && v.nivel === variables.nivel).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.profesor_clase === variables.profesor && v.nivel === variables.nivel)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia === "") && (variables.nivel != "") && (variables.categoria != "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.nivel === variables.nivel && v.categoria === variables.categoria).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.nivel === variables.nivel && v.categoria === variables.categoria)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia === "") && (variables.nivel != "") && (variables.categoria != "") && (variables.profesor != "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.nivel === variables.nivel && v.categoria === variables.categoria && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.nivel === variables.nivel && v.categoria === variables.categoria && v.profesor_clase === variables.profesor)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia != "") && (variables.nivel === "") && (variables.categoria === "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia))).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia != "") && (variables.nivel === "") && (variables.categoria === "") && (variables.profesor != "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia) && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia) && v.profesor_clase === variables.profesor)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia != "") && (variables.nivel === "") && (variables.categoria != "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia) && v.categoria === variables.categoria).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia) && v.categoria === variables.categoria)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia != "") && (variables.nivel === "") && (variables.categoria != "") && (variables.profesor != "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia) && v.categoria === variables.categoria && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia) && v.categoria === variables.categoria && v.profesor_clase === variables.profesor)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia != "") && (variables.nivel != "") && (variables.categoria === "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia) && v.nivel === variables.nivel).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia) && v.nivel === variables.nivel)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia != "") && (variables.nivel != "") && (variables.categoria === "") && (variables.profesor != "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia) && v.nivel === variables.nivel && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia) && v.nivel === variables.nivel && v.profesor_clase === variables.profesor)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : (variables.dia != "") && (variables.nivel != "") && (variables.categoria != "") && (variables.profesor === "") ?
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia) && v.categoria === variables.categoria && v.nivel === variables.nivel).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia) && v.categoria === variables.categoria && v.nivel === variables.nivel)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                        : 
                            !variables.search ?
                                filteredClinics.filter((v) => v.dias.includes(variables.dia) && v.categoria === variables.categoria && v.nivel === variables.nivel && v.profesor_clase === variables.profesor).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                            :
                                filteredClinics.filter((v, i) => (v.nombre_clase.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()) || 
                                v.nombre_profesor.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.search.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())) && (v.dias.includes(variables.dia) && v.categoria === variables.categoria && v.nivel === variables.nivel && v.profesor_clase === variables.profesor)).map((v, i) => {
                                    //Funcion que formatea el subitulo
                                    const formatSubtitle = () => {
                                        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
                                            var dias = ""
                                            v.dias_clase.map(v => {
                                                var dia = ""
                                                var hora = v.de + "-" + v.a
                                                for(let i = 0; i < 3; i++){
                                                    dia += v.dia[i]
                                                }

                                                if(dias == ""){
                                                    dias = dia + " " + hora
                                                } else {
                                                    dias += " / " + dia + " " + hora
                                                }

                                            })

                                            return dias
                                        } else {
                                            return ""
                                        }
                                    }

                                    return (
                                        <div className='class'>

                                            <p className='classTitle' style={{
                                                fontFamily: fontType.subTitle
                                            }}> {v.nombre_clase} ({v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}) </p>
                                            <Link className='classInfo' style={{ backgroundColor: 
                                                v.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                                                v.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                                                v.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                                                v.nivel == "Clase D" ? levelColors.Clase_D :
                                                v.nivel == "Clase C" ? levelColors.Clase_C :
                                                v.nivel == "Clase B" ? levelColors.Clase_B :
                                                v.nivel == "Clase A" ? levelColors.Clase_A :
                                                v.nivel == "Profesional" ? levelColors.Profesional : null
                                            }} to={"/classes/class"} state={{
                                                ref: ref,
                                                id: v.id,
                                                academia: academia
                                            }}>
                                                <p className='classDays' style={{
                                                    fontFamily: fontType.text
                                                }}> {formatSubtitle()} </p>
                                                <p className='classTeacher' style={{
                                                    fontFamily: fontType.text
                                                }}>
                                                    {v.nombre_profesor}
                                                    {v.nombre_profesor_secundario && ` / ${v.nombre_profesor_secundario}`}
                                                </p>
                                            </Link>

                                        </div>
                                    )
                                })
                    }
                </div>
            </div>

        </div>
    )
    }
}

export default Classes